@if (currentBannerImg) {
  <href class="overflow-hidden"
    sizeClass="XL: ratio-banner, SM: ratio-3-1"
    (click)="trackClick()"
    [link]="currentBanner.redirectUrl">
    <local-shell />
    <img [image]="currentBannerImg"
      [options]="{fitIn: true}"
      class="rf">
</href>
}